import { Component, OnInit, Injector, Input, ViewChild, OnDestroy, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DashboardViewConfigurationService } from './dashboard-view-configuration.service';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { GridsterConfig } from 'angular-gridster2';
import type { GridsterItemConfig } from 'angular-gridster2';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardCustomizationServiceProxy, DashboardOutput, AddNewPageInput, AddNewPageOutput, AddWidgetInput, RenamePageInput, SavePageInput, Page, Widget, WidgetFilterOutput, WidgetOutput } from '@shared/service-proxies/service-proxies';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { WidgetViewDefinition, WidgetFilterViewDefinition } from './definitions';
import { AddWidgetModalComponent } from './add-widget-modal/add-widget-modal.component';
import { DashboardCustomizationConst } from './DashboardCustomizationConsts';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as rtlDetect from 'rtl-detect';
import { HeaderTitle } from '../header-title/header-title.model';
import { BreadcrumbItem } from '../sub-header/sub-header.component';
import { HeaderTitleService } from '../header-title/header-title.service';
import { SidePanelCheckService } from '../../services/side-panel-check.service';
import { CandleBaseDirective } from '../../../main/activities/directives/candle-base.directive';
import { ProductivityBarComponent } from '../../../main/activities/shared/productivity-bar/productivity-bar.component';
import { DefaultLayoutService } from '../../layout/themes/default/default-layout.service';
@Component({
    standalone: false,
    selector: 'customizable-dashboard',
    templateUrl: './customizable-dashboard.component.html',
    styleUrls: ['./customizable-dashboard.component.css'],
    animations: [appModuleAnimation()],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomizableDashboardComponent extends AppComponentBase implements OnInit, OnDestroy, OnChanges {
    @Input()
    dashboardName: string;
    isSidebarOpen: boolean = false;
    @ViewChild('addWidgetModal')
    addWidgetModal: AddWidgetModalComponent;
    @ViewChild('dashboardTabs')
    dashboardTabs: TabsetComponent;
    @ViewChild('filterModal', { static: true })
    modal: ModalDirective;
    @ViewChild('dropdownRenamePage')
    dropdownRenamePage: BsDropdownDirective;
    @ViewChild('dropdownAddPage')
    dropdownAddPage: BsDropdownDirective;
    @ViewChild('dashboardTabsView', { static: false })
    dashboardTabsView: TabsetComponent;
    @ViewChild(CandleBaseDirective)
    candleDiective: CandleBaseDirective;
    @ViewChild(ProductivityBarComponent)
    ProductivityBar: ProductivityBarComponent;
    loading = true;
    busy = true;
    editModeEnabled = false;
    myProfileshow = false;
    dashboardDefinition: DashboardOutput;
    //gridster options. all gridster needs its options. In our scenario, they are all same.
    options: GridsterConfig[] = [];
    isAccountant: boolean = false;
    userDashboard: any;
    checkEmployee = false;
    selectedPage = {
        id: '',
        name: ''
    };
    firstDashboardVisit: boolean = true;
    renamePageInput = '';
    addPageInput = '';
    userDesignation: string;
    dashboardTab: number = 1;
    leavesCards = [
        { id: 1, name: 'ArrivalTime', price: '09:30 hours', icon: 'assets/common/images/new-dashboard/ArrivalTimeUpdate.svg', class: 'ArrivalText' },
        { id: 2, name: 'LeftTime', price: 'ONLINE', icon: 'assets/common/images/new-dashboard/LeftTimeUpdate.svg', class: 'leftTImetext' },
        { id: 3, name: 'ProductiveTime', price: '09:30 hours', icon: 'assets/common/images/new-dashboard/ProductiveTimeUpdate.svg', class: 'text-warning' },
        { id: 4, name: 'InTimeProTime', price: '09:30 hours', icon: 'assets/common/images/new-dashboard/IntimeProTimeUpdate.svg', class: 'text-success' },
        { id: 5, name: 'TimeAtWorks', price: '09:30 hours', icon: 'assets/common/images/new-dashboard/timeworkUpdate.svg', class: 'text-danger' },
        { id: 6, name: 'PlaceinGroup', price: '3rd', icon: 'assets/common/images/new-dashboard/PlacedAtGroupUpdate.svg', class: 'text-info' },
        { id: 7, name: 'Effectiveness', price: '80%', icon: 'assets/common/images/new-dashboard/Effectivenessupdate.svg', class: 'text-warning' },
        { id: 8, name: 'Productivity', price: '80%', icon: 'assets/common/images/new-dashboard/Productivityupdate.svg', class: 'text-danger' }
    ];
    isLoaded = false;
    isEmpty = true;
    constructor(injector: Injector, private _dashboardViewConfiguration: DashboardViewConfigurationService, private _spinnerService: NgxSpinnerService, private headerTitleService: HeaderTitleService, private _dashboardCustomizationServiceProxy: DashboardCustomizationServiceProxy, private designUitility: SidePanelCheckService, private _defaultLayoutService: DefaultLayoutService) {
        super(injector);
    }
    async ngOnInit() {
        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem('Dashboard'),
            new BreadcrumbItem('My Dashboard')
        ]));
        this.loading = true;
        this._spinnerService.show();
        this._defaultLayoutService.getLatestValue().subscribe(x => {
            localStorage.setItem('DashboardValue', JSON.stringify(x));
            if (x) {
                this.DashboardTabResponse();
            }
            this.markForCheck();
        });
        this.dashboardTab = 1;
        let myprofileDetails = (localStorage.getItem('MyProfileDetails'));
        let myProfileUser = JSON.parse(myprofileDetails);
        this.userDesignation = myProfileUser?.designation;
        if (this.userDesignation != 'Accountant,') {
            this.display();
        }
        else {
            this.isAccountant = true;
        }
        this.subAsideTogglerClick();
    }
    DashboardTabResponse() {
        let r = JSON.parse(localStorage.getItem('DashboardValue'));
        if (r) {
            let result = r;
            if (result == 1) {
                this.dashboardTab = result;
                this.dashboardTab = 1;
            }
            else {
                this.dashboardTab = result;
                this.dashboardTab = 2;
            }
        }
    }
    ngAfterViewInit() {
    }
    ngOnChanges() {
        this.designUitility.userName.subscribe(x => {
            if (x) {
                this.isSidebarOpen = true;
            }
            this.markForCheck();
        });
    }
    display() {
        this._dashboardCustomizationServiceProxy.getDashboardDefinition(this.dashboardName, DashboardCustomizationConst.Applications.Angular)
            .subscribe((dashboardDefinitionResult: DashboardOutput) => {
            this.dashboardDefinition = dashboardDefinitionResult;
            if (!this.dashboardDefinition.widgets || this.dashboardDefinition.widgets.length === 0) {
                this.busy = false;
                this.loading = false;
                return;
            }
            let savedUserDashboard = this.getUserDashboard(this.dashboardName);
            if (this.userDesignation === 'Contractor') {
                savedUserDashboard.Pages = savedUserDashboard.Pages.filter(x => x.Name !== 'Team Dashboard');
                this.checkEmployee = true;
            }
            if (this.userDesignation === 'Employee') {
                savedUserDashboard.Pages = savedUserDashboard.Pages.filter(x => x.Name !== 'Team Dashboard');
                this.checkEmployee = true;
            }
            this.initializeUserDashboardDefinition(savedUserDashboard, dashboardDefinitionResult);
            this.initializeUserDashboardFilters();
            //select first page (if user delete all pages server will add default page to userDashboard.)
            this.selectedPage = {
                id: this.userDashboard.pages[0].id,
                name: this.userDashboard.pages[0].name
            };
            this.loading = false;
            this._spinnerService.hide();
            this.busy = false;
            this.markForCheck();
        });
    }
    ngOnDestroy(): void {
        this.unSubAsideTogglerClick();
        localStorage.removeItem('DashboardValue');
    }
    initializeUserDashboardDefinition(savedUserDashboard: any, dashboardDefinitionResult: DashboardOutput) {
        this.userDashboard = {
            dashboardName: this.dashboardName,
            filters: [],
            pages: savedUserDashboard.Pages.map(page => {
                //gridster should has its own options
                this.options.push(this.getGridsterConfig());
                if (!page.Widgets) {
                    return {
                        id: page.Id,
                        name: page.Name,
                        widgets: []
                    };
                }
                var z: any;
                //Top Stats Section
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_TopStats' && !this.isGranted('Pages.Top.Stats')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                //user arrival info section
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_ArrivalInfo' && !this.isGranted('Pages.ArrivaltimeSection.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_RegionalStats' && !this.isGranted('Pages.Regional.Stat')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                //organization section 
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_OrgUnits' && !this.isGranted('Pages.OrgUnit.Widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                //leave report section
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_LeaveReports' && !this.isGranted('Pages.LeaveReportsSection.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_GeneralStats' && !this.isGranted('Pages.General.Stat')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_MyTimesheettab' && !this.isGranted('Pages.Timesheet.Tab')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_UnProductiveAppsSection' && !this.isGranted('Pages.UnProductiveAppsSection.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_ProductiveAppsSection' && !this.isGranted('Pages.ProductiveAppsSection.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_ProductivityChartInfo' && !this.isGranted('Pages.ProductiveAppsChart.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_NeutralAppsSection' && !this.isGranted('Pages.NeutralAppsSection.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_ProjectInfoTab' && !this.isGranted('Pages.FirsttabProjectDetailsSection.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_TaskListSection' && !this.isGranted('Pages.TaskList.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_SecondTabProjectsCountInfo' && !this.isGranted('Pages.SecondTabProject.CountInfo')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_ProductivityChartInfo' && !this.isGranted('Pages.ProductiveAppsChart.widget')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_SecondTabNewJoinerSections' && !this.isGranted('Pages.SecondTabNewJoiner.Section')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_SecondTabEmployeeSection' && !this.isGranted('Pages.SecondTabEmployee.Section')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_SecondTabProjectSection' && !this.isGranted('Pages.SecondTabProject.Section')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_SecondTabLeaveReports' && !this.isGranted('Pages.SecondTabLeaveReports.Section')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_SecondTabTeamTimesheetSection' && !this.isGranted('Pages.SecondTabTeamTimesheet.Section')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                page.Widgets.forEach((item, index) => {
                    if (item.WidgetId === 'Widgets_Tenant_SecondTabTeamDetailsSection' && !this.isGranted('Pages.SecondTabTeamDetails.Section')) {
                        page.Widgets.splice(index, 1);
                    }
                });
                //only use widgets which dashboard definition contains and have view definition
                //(dashboard definition can be changed after users save their dashboard, because it depends on permissions and other stuff)
                page.Widgets = page.Widgets.filter(w => dashboardDefinitionResult.widgets.find(d => d.id === w.WidgetId) && this.getWidgetViewDefinition(w.WidgetId));
                return {
                    id: page.Id,
                    name: page.Name,
                    widgets: page.Widgets.map(widget => {
                        return {
                            id: widget.WidgetId,
                            //View definitions are stored in the angular side(a component of widget/filter etc.) get view definition and use defined component
                            component: this.getWidgetViewDefinition(widget.WidgetId).component,
                            gridInformation: {
                                id: widget.WidgetId,
                                cols: widget.Width,
                                rows: widget.Height,
                                x: widget.PositionX,
                                y: widget.PositionY,
                            }
                        };
                    })
                };
            })
        };
    }
    removeItem(item: GridsterItemConfig) {
        let page = this.userDashboard.pages.find(p => p.id === this.selectedPage.id);
        let widget = page.widgets.find(w => w.id === item.id);
        let widgetDefinition = this.dashboardDefinition.widgets.find((widgetDef: WidgetOutput) => widgetDef.id === item.id);
        if (!widget || !widgetDefinition) {
            return;
        }
        this.message.confirm(this.l('WidgetDeleteWarningMessage', this.l(widgetDefinition.name), this.selectedPage.name), this.l('AreYouSure'), isConfirmed => {
            if (isConfirmed) {
                page.widgets.splice(page.widgets.indexOf(widget), 1);
            }
        });
    }
    addWidget(widgetId: any): void {
        if (!widgetId) {
            return;
        }
        let widgetViewConfiguration = this._dashboardViewConfiguration.WidgetViewDefinitions.find(w => w.id === widgetId);
        if (!widgetViewConfiguration) {
            abp.notify.error(this.l('ThereIsNoViewConfigurationForX', widgetId));
            return;
        }
        let page = this.userDashboard.pages.find(page => page.id === this.selectedPage.id);
        if (page.widgets.find(w => w.id === widgetId)) {
            return;
        }
        this.busy = true;
        this._dashboardCustomizationServiceProxy.addWidget(new AddWidgetInput({
            widgetId: widgetId,
            pageId: this.selectedPage.id,
            dashboardName: this.dashboardName,
            width: widgetViewConfiguration.defaultWidth,
            height: widgetViewConfiguration.defaultHeight,
            application: DashboardCustomizationConst.Applications.Angular
        })).subscribe((addedWidget) => {
            this.userDashboard.pages.find(page => page.id === this.selectedPage.id).widgets.push({
                id: widgetId,
                component: widgetViewConfiguration.component,
                gridInformation: {
                    id: widgetId,
                    cols: addedWidget.width,
                    rows: addedWidget.height,
                    x: addedWidget.positionX,
                    y: addedWidget.positionY,
                }
            });
            this.initializeUserDashboardFilters();
            this.busy = false;
            this.notify.success(this.l('SavedSuccessfully'));
            this.markForCheck();
        });
    }
    private getUserDashboards(): any[] {
        let settings = this.s('App.DashboardCustomization.Configuration' + '.' + DashboardCustomizationConst.Applications.Angular);
        let obj = JSON.parse(settings);
        return obj;
    }
    private getUserDashboard(name: string) {
        return this.getUserDashboards().filter(dashboard => dashboard.DashboardName === name)[0];
    }
    private getWidgetViewDefinition(id: string): WidgetViewDefinition {
        return this._dashboardViewConfiguration.WidgetViewDefinitions.find(widget => widget.id === id);
    }
    private getWidgetFilterViewDefinition(id: string): WidgetFilterViewDefinition {
        return this._dashboardViewConfiguration.widgetFilterDefinitions.find(filter => filter.id === id);
    }
    changeEditMode(): void {
        this.editModeEnabled = !this.editModeEnabled;
        //change all gridster options
        this.refreshAllGrids();
    }
    refreshAllGrids(): void {
        if (this.options) {
            this.options.forEach(option => {
                option.draggable.enabled = this.editModeEnabled;
                option.resizable.enabled = this.editModeEnabled;
                option.api?.optionsChanged();
            });
        }
    }
    openAddWidgetModal(): void {
        let page = this.userDashboard.pages.find(page => page.id === this.selectedPage.id);
        if (page) {
            let widgets = this.dashboardDefinition.widgets.filter((widgetDef: WidgetOutput) => !page.widgets.find(widgetOnPage => widgetOnPage.id === widgetDef.id));
            this.addWidgetModal.show(widgets);
        }
    }
    addNewPage(pageName: string): void {
        if (!pageName || pageName.trim() === '') {
            this.notify.warn(this.l('PageNameCanNotBeEmpty'));
            return;
        }
        pageName = pageName.trim();
        this.busy = true;
        this._dashboardCustomizationServiceProxy.addNewPage(new AddNewPageInput({
            dashboardName: this.dashboardName,
            name: pageName,
            application: DashboardCustomizationConst.Applications.Angular
        })).subscribe((result: AddNewPageOutput) => {
            //gridster options for new page
            this.options.push(this.getGridsterConfig());
            if (this.isGranted(''))
                this.userDashboard.pages.push({
                    id: result.pageId,
                    name: pageName,
                    widgets: []
                });
            this.busy = false;
            this.notify.success(this.l('SavedSuccessfully'));
            if (this.selectedPage.id === '') {
                this.selectPageTab(result.pageId);
            }
            this.markForCheck();
        });
        this.dropdownAddPage.hide();
    }
    selectPageTab(pageId: string): void {
        if (!pageId) {
            this.selectedPage = {
                id: '',
                name: ''
            };
            return;
        }
        this.firstDashboardVisit = false;
        this.selectedPage = {
            id: pageId,
            name: this.userDashboard.pages.find(page => page.id === pageId).name
        };
        if (this.selectedPage.name == 'Team Dashboard') {
            this.headerTitleService.setPageTitle(new HeaderTitle([
                new BreadcrumbItem(this.l('Dashboard')),
                new BreadcrumbItem('Team Dashboard')
            ]));
        }
        else {
            this.headerTitleService.setPageTitle(new HeaderTitle([
                new BreadcrumbItem(this.l('Dashboard')),
                new BreadcrumbItem('My Dashboard')
            ]));
        }
        //when tab change gridster should redraw because if a tab is not active gridster think that its height is 0 and do not draw it.
        this.options.forEach(option => {
            if (option.api) {
            }
        });
    }
    renamePage(pageName: string): void {
        if (!pageName || pageName === '') {
            this.notify.warn(this.l('PageNameCanNotBeEmpty'));
            return;
        }
        pageName = pageName.trim();
        this.busy = true;
        let pageId = this.selectedPage.id;
        this._dashboardCustomizationServiceProxy.renamePage(new RenamePageInput({
            dashboardName: this.dashboardName,
            id: pageId,
            name: pageName,
            application: DashboardCustomizationConst.Applications.Angular
        })).subscribe(() => {
            let dashboardPage = this.userDashboard.pages.find(page => page.id === pageId);
            dashboardPage.name = pageName;
            this.notify.success(this.l('Renamed'));
            this.busy = false;
            this.markForCheck();
        });
        this.dropdownRenamePage.hide();
    }
    deletePage(): void {
        let message = this.userDashboard.pages.length > 1
            ? this.l('PageDeleteWarningMessage', this.selectedPage.name)
            : this.l('BackToDefaultPageWarningMessage', this.selectedPage.name);
        this.message.confirm(message, this.l('AreYouSure'), isConfirmed => {
            if (isConfirmed) {
                this.busy = true;
                this._dashboardCustomizationServiceProxy.deletePage(this.selectedPage.id, this.dashboardName, DashboardCustomizationConst.Applications.Angular)
                    .subscribe(() => {
                    let dashboardPage = this.userDashboard.pages.find(page => page.id === this.selectedPage.id);
                    this.options.pop(); // since all of our gridster has same options, its not important which options we are removing
                    this.userDashboard.pages.splice(this.userDashboard.pages.indexOf(dashboardPage), 1);
                    this.activateFirstPage();
                    this.busy = false;
                    this.notify.success(this.l('SuccessfullyRemoved'));
                    if (this.userDashboard.pages.length === 0) {
                        window.location.reload();
                    }
                    this.markForCheck();
                });
            }
        });
    }
    activateFirstPage() {
        if (this.userDashboard.pages[0]) {
            setTimeout(() => {
                let tab = this.dashboardTabs.tabs[0];
                tab.active = true;
            }, 0);
            this.selectPageTab(this.userDashboard.pages[0].id);
            this.initializeUserDashboardFilters();
        }
        else {
            this.selectPageTab(null);
        }
    }
    savePage(): void {
        this.busy = true;
        let savePageInput = new SavePageInput({
            dashboardName: this.dashboardName,
            pages: this.userDashboard.pages.map(page => {
                return new Page({
                    id: page.id,
                    name: page.name,
                    widgets: page.widgets.map(widget => {
                        return new Widget({
                            widgetId: widget.gridInformation.id,
                            height: 1000,
                            width: widget.gridInformation.cols,
                            positionX: widget.gridInformation.x,
                            positionY: widget.gridInformation.y,
                        });
                    })
                });
            }),
            application: DashboardCustomizationConst.Applications.Angular
        });
        this._dashboardCustomizationServiceProxy.savePage(savePageInput)
            .subscribe(() => {
            this.changeEditMode(); //after changes saved close edit mode
            this.initializeUserDashboardFilters();
            this.busy = false;
            this.notify.success(this.l('SavedSuccessfully'));
            window.location.reload();
            this.markForCheck();
        });
    }
    //all pages use gridster and its where they get their options. Changing this will change all gristers.
    private getGridsterConfig(): GridsterConfig {
        const isRtl = rtlDetect.isRtlLang(abp.localization.currentLanguage.name);
        return {
            disableWarnings: true,
            pushItems: true,
            draggable: {
                enabled: this.editModeEnabled
            },
            resizable: {
                enabled: false
            },
            gridType: "scrollVertical",
            keepFixedHeightInMobile: false,
            keepFixedWidthInMobile: false,
            mobileBreakpoint: 640,
            useBodyForBreakpoint: false,
            maxCols: 14,
            avoid_overlapped_widgets: true,
            dirType: isRtl ? 'rtl' : 'ltr'
        };
    }
    moreThanOnePage(): boolean {
        return this.userDashboard && this.userDashboard.pages && this.userDashboard.pages.length > 1;
    }
    close(): void {
        this.modal.hide();
    }
    addPageDropdownShown(): void {
        this.addPageInput = '';
    }
    renamePageDropdownShown(): void {
        this.renamePageInput = '';
    }
    //after we load page or add widget initialize needed filter too.
    private initializeUserDashboardFilters(): void {
        let allFilters: WidgetFilterOutput[] = [];
        this.dashboardDefinition.widgets
            .filter(widget => widget.filters != null && widget.filters.length > 0)
            .forEach(widget => {
            if (this.userDashboard.pages) {
                this.userDashboard.pages.forEach(page => {
                    //if user has this widget in any page
                    if (page?.widgets?.filter(userWidget => userWidget.id === widget.id).length !== 0) {
                        widget.filters
                            .forEach(filter => {
                            if (!allFilters.find(f => f.id === filter.id)) {
                                allFilters.push(filter);
                            }
                        });
                    }
                });
            }
        });
        this.userDashboard.filters = allFilters.map(filter => {
            let definition = this.getWidgetFilterViewDefinition(filter.id);
            definition['name'] = filter.name;
            return definition;
        });
    }
    subAsideTogglerClick() {
        abp.event.on('app.kt_aside_toggler.onClick', this.onMenuToggle);
    }
    unSubAsideTogglerClick() {
        abp.event.off('app.kt_aside_toggler.onClick', this.onMenuToggle);
    }
    onMenuToggle = () => {
        this.refreshAllGrids();
    };
    //Function to display Third Tab
    addNewTask(e) {
        if (e == '1') {
            this.myProfileshow = true;
        }
        else {
            this.myProfileshow = false;
        }
    }
    //function to hide dashbaord on click
    dashboardprofileHide() {
        this.myProfileshow = false;
        this.dashboardTabsView.tabs[1].active = true;
    }
}
